import { useQueryClient } from '@tanstack/react-query';

import { useCommunityActionBase } from './useCommunityActionBase';
import { SCHEDULED_POSTS_QUERY_KEY } from './useCommunityScheduledPosts';

interface RescheduleVars {
  scheduledPostId: string;
  scheduledAt: Date;
}

// A refused time reloads the queue too: the post may have started publishing after the queue loaded.
const useRescheduleCommunityScheduledPostMutation = () => {
  const queryClient = useQueryClient();

  return useCommunityActionBase<RescheduleVars>({
    buildRequest: ({ scheduledPostId, scheduledAt }) => ({
      path: '/update_community_scheduled_post',
      fields: { scheduled_post_id: scheduledPostId, scheduled_at: scheduledAt.toISOString() },
    }),
    onSettled: () => queryClient.invalidateQueries({ queryKey: SCHEDULED_POSTS_QUERY_KEY }),
  });
};

export default useRescheduleCommunityScheduledPostMutation;
